import * as administrator from "./administrator";
import * as common from "./common";

const put = {
  administrator,
  common,
};

export default put;
